// extracted by mini-css-extract-plugin
export default {"main":"Header_main__+oKc8","link":"Header_link__xIhZh"};